// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UApo","footer":"styles_footer__2vtrt"};